import React from 'react';
import './PLPFacilitiesSection.scss';
import { Container, Section } from 'components/core/Page';
import { H2 } from 'components/core/Typography';
import { FacilityCard } from 'components/search/FacilityCard';
import PropTypes from 'prop-types';
import { getNearbyFacilities } from 'store/selectors/getNearbyFacilities';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import ScrollWrapper from 'components/molecules/ScrollWrapper/ScrollWrapper';
import {
	getLocalPhoneNumberByZipCode,
	getLocalPhoneNumberByCityState,
} from 'store/pageMeta/actions';

const enhance = compose(
	connect(
		(state) => ({
			nearbyFacilities: getNearbyFacilities(state),
		}),
		{
			getLocalPhoneNumberByZipCode,
			getLocalPhoneNumberByCityState,
		}
	)
);

function PLPFacilitiesSection(props) {
	if (!props?.nearbyFacilities) {
		return null;
	}
	const location = props?.nearbyFacilities?.location;
	const facilities =
		props?.nearbyFacilities?.facilityCollection.collection || [];
	return (
		<Section className={'facilities-section'} id="facilities-nearby">
			<Container>
				<div className="plp-section-title">
					<H2
						weight="bold"
						color="black"
						className="plp-section-title-header"
					>
						Popular facilities Near {location.text}
					</H2>
					
					{/* The 'Compare' Button below needs to be updated in  */}
					{/* a newer version of this. Right now it uses the 'old' */}
					{/* geoDetection - not the new cloudflare location headers */}

					{/* <Paragraph>
						<Button
							href="/storage-deals"
							link
							className="plp-section-title-link"
						>
							Compare All Nearby Storage Deals
						</Button>
						<SFIcon icon="chevron-right" />
					</Paragraph> */}
				</div>
			</Container>
			<ScrollWrapper
				className={'plp-facility-card-arrangement'}
				slug={'nearby-facilities'}
			>
				{facilities?.map((facility, index) => (
					<FacilityCard
						key={facility.id}
						searchLocation={location}
						facility={facility}
						phone={'112asd3'}
						className="scroll-card nearby-facility-card"
						page="paid"
						position={index + 1}
						lazyLoad={true}
						getLocalPhoneNumberByCityState={
							props.getLocalPhoneNumberByCityState
						}
						getLocalPhoneNumberByZipCode={
							props.getLocalPhoneNumberByZipCode
						}
					/>
				))}
			</ScrollWrapper>
		</Section>
	);
}

PLPFacilitiesSection.propTypes = {
	nearbyFacilities: PropTypes.object,
	getLocalPhoneNumberByCityState: PropTypes.func,
	getLocalPhoneNumberByZipCode: PropTypes.func,
};

export default enhance(PLPFacilitiesSection);
